import { useMemo } from 'react';
import styled from 'styled-components';

import theme from '../../assets/theme';
import { SlideElementShapeType } from './slide.types';

const SlideElementShape = ({ element }: { element?: SlideElementShapeType }) => {
  const backgroundColor = useMemo(() => {
    if (element?.colors?.length) {
      return element.colors?.[0];
    }
    return theme.colors.greyDark;
  }, [element]);
  return (
    <PreventAntialiasingContainer>
      <SlideElementShapeContainer
        $color={backgroundColor}
        $clipPath={element?.shapeClipPath}
      ></SlideElementShapeContainer>
    </PreventAntialiasingContainer>
  );
};

const SlideElementShapeContainer = styled.div<{ $color?: string; $clipPath?: string }>`
  width: 100%;
  height: 100%;
  background-color: ${({ $color }) => $color || theme.colors.greyDark};
  clip-path: ${({ $clipPath }) => $clipPath};
`;
const PreventAntialiasingContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 3px;
`;

export default SlideElementShape;
